var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("map-layout", {
    attrs: {
      moduleCode: _vm.moduleCode,
      enableHeader: false,
      enableFooter: false,
      enableMainSidebar: false,
      navTopMenu: false,
      swipeMenu: false,
      mainSidebarOnlyMobile: false,
      fixedTopMenuDashboard: false,
    },
    scopedSlots: _vm._u(
      [
        {
          key: "main",
          fn: function () {
            return [_vm._t("main")]
          },
          proxy: true,
        },
        {
          key: "aside-control",
          fn: function () {
            return [_vm._t("aside-control")]
          },
          proxy: true,
        },
      ],
      null,
      true
    ),
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }